export default function BackgroundSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-start">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-8">My creative journey</h2>
            <div className="space-y-6 text-gray-600 leading-relaxed">
              <p>
                I began my career as a Master Photographer with Lifetouch, capturing portraits and large-scale events. This experience honed my technical precision, attention to detail, and ability to perform under pressure while connecting with people through photography.
              </p>
              <p>
                I then joined Blue Prints, where I helped establish the company's creative direction and now lead a multidisciplinary team producing high-impact visuals for events, marketing campaigns, and branded content. A highlight of my work has been collaborating with the Los Angeles Dodgers at Dodger Stadium, designing and photographing interactive photo experiences that engage fans and transform live events into immersive, shareable moments.
              </p>
              <p>
                Within Blue Prints, I also co-founded PRIMs Photo Booth, a high-end photo experience brand that extends our creative offerings into experiential marketing. PRIMs combines event photography with custom design and production, helping clients bring their brand identities to life through memorable on-site activations.
              </p>
              <p>
                I hold a BFA in Photography from California State University, Long Beach, graduating Summa Cum Laude, and have been recognized with multiple awards for creativity and community impact. My expertise includes Adobe Creative Suite, WordPress, and end-to-end production for both print and digital media.
              </p>
              <p>
                At my core, I'm a storyteller who believes great visuals are built on connection — between brand and audience, concept and emotion, and light and design. I enjoy collaborating with teams that value creativity, innovation, and thoughtful visual communication.
              </p>
            </div>
          </div>
          
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-sm shadow-sm">
              <h3 className="text-xl font-medium text-gray-900 mb-4">Education</h3>
              <div className="space-y-4">
                <div>
                  <div className="font-medium text-gray-900">Bachelor of Fine Arts, Photography</div>
                  <div className="text-gray-600">California State University, Long Beach</div>
                  <div className="text-sm text-gray-500">Summa Cum Laude</div>
                </div>
              </div>
            </div>
            
            <div className="bg-white p-8 rounded-sm shadow-sm">
              <h3 className="text-xl font-medium text-gray-900 mb-4">Philosophy</h3>
              <p className="text-gray-600 leading-relaxed">
                I believe great visuals are built on connection — between brand and audience, concept and emotion, and light and design. My approach combines technical precision with creative storytelling, always keeping authentic human connection at the center of every project.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
